/**
 * Products archive — client-side filter / sort / paginate.
 *
 * Operates on the .chada-card-col wrappers (data-name/price/cats/featured)
 * inside #chada-grid. Page size 3, matching the handoff. Pager auto-hides
 * at ≤1 page; empty state shows when nothing matches.
 */
export function initProductsArchive() {
	const grid = document.getElementById('chada-grid');
	if (!grid) return;

	const cards = Array.from(grid.querySelectorAll('.chada-card-col'));
	const empty = document.getElementById('chada-empty');
	const countEl = document.getElementById('chada-count');
	const pager = document.getElementById('chada-pager');
	const filters = document.getElementById('chada-filters');
	const searchEl = document.getElementById('chada-search');
	const sortEl = document.getElementById('chada-sort');
	const PAGE_SIZE = 3;
	const state = { cat: 'all', q: '', sort: 'featured', page: 1 };

	const matches = (card) => {
		const cats = ' ' + (card.dataset.cats || '') + ' ';
		const okCat = state.cat === 'all' || cats.indexOf(' ' + state.cat + ' ') !== -1;
		const q = state.q.trim().toLowerCase();
		if (!q) return okCat;
		const name = (card.dataset.name || '').toLowerCase();
		const desc = (card.querySelector('.pc-desc')?.textContent || '').toLowerCase();
		const cat = (card.querySelector('.pc-cat')?.textContent || '').toLowerCase();
		return okCat && (name.includes(q) || desc.includes(q) || cat.includes(q));
	};

	const sortList = (list) => {
		const s = state.sort;
		return list.sort((a, b) => {
			if (s === 'price-asc') return (+a.dataset.price) - (+b.dataset.price);
			if (s === 'price-desc') return (+b.dataset.price) - (+a.dataset.price);
			if (s === 'name') return (a.dataset.name || '').localeCompare(b.dataset.name || '');
			return (+a.dataset.featured) - (+b.dataset.featured);
		});
	};

	const pgBtn = (label, page, opts = {}) => {
		const b = document.createElement('button');
		b.type = 'button';
		b.className = 'pgbtn' + (opts.active ? ' active' : '');
		b.innerHTML = label;
		if (opts.disabled) b.disabled = true;
		else b.addEventListener('click', () => { state.page = page; render(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
		return b;
	};

	const renderPager = (pages) => {
		pager.innerHTML = '';
		if (pages <= 1) return;
		pager.appendChild(pgBtn('‹ Prev', state.page - 1, { disabled: state.page === 1 }));
		for (let i = 1; i <= pages; i++) pager.appendChild(pgBtn(String(i), i, { active: i === state.page }));
		pager.appendChild(pgBtn('Next ›', state.page + 1, { disabled: state.page === pages }));
	};

	const render = () => {
		const list = sortList(cards.filter(matches));
		// Cards carry Bootstrap's `.d-flex` (display:flex !important), which beats a
		// plain inline `display:none` — hide with an !important inline rule so the
		// non-matching tiles actually disappear; show by clearing it (d-flex resumes).
		cards.forEach((c) => { c.style.setProperty('display', 'none', 'important'); });

		const total = list.length;
		const pages = Math.max(1, Math.ceil(total / PAGE_SIZE));
		state.page = Math.min(Math.max(1, state.page), pages);

		list.forEach((c) => grid.appendChild(c)); // reorder DOM to sorted order
		const start = (state.page - 1) * PAGE_SIZE;
		const slice = list.slice(start, start + PAGE_SIZE);
		slice.forEach((c) => { c.style.removeProperty('display'); });

		if (empty) empty.style.display = total === 0 ? 'block' : 'none';

		if (countEl) {
			countEl.innerHTML = total === 0
				? 'No plugins found'
				: 'Showing <b>' + (start + 1) + '–' + (start + slice.length) + '</b> of <b>' + total + '</b> plugin' + (total === 1 ? '' : 's');
		}
		renderPager(pages);
	};

	if (filters) {
		filters.addEventListener('click', (e) => {
			const chip = e.target.closest('.chip');
			if (!chip) return;
			filters.querySelectorAll('.chip').forEach((c) => c.classList.remove('active'));
			chip.classList.add('active');
			state.cat = chip.dataset.cat;
			state.page = 1;
			render();
		});
	}
	if (searchEl) searchEl.addEventListener('input', function () { state.q = this.value; state.page = 1; render(); });
	if (sortEl) sortEl.addEventListener('change', function () { state.sort = this.value; state.page = 1; render(); });

	render();
}
